import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';
import FormTickBox from '../../components/form/FormTickBox/FormTickBox';

const FormTickBoxContainer = props =>
  <Field
    name={props.name}
    component={FormTickBox}
    props={props}
  />
;

FormTickBoxContainer.propTypes = {
  name: PropTypes.string
};

export default FormTickBoxContainer;



/** WEBPACK FOOTER **
 ** ./src/redux/containers/FormTickBoxContainer.js
 **/